<template>
  <div
    class="steps"
    v-if="data && data.question[data.questionIndex].que_type != 7"
  >
    <div class="pre">
      <div v-show="showPre" @click="bindPre" class="back">
        <span class="iconfont icon-fanhui"></span><span>上一题</span>
      </div>
    </div>
    <div class="content">
      <div
        class="line"
        :style="{ width: progress, background: theme.stepColor }"
      ></div>
    </div>
    <div class="cur">{{ index }}/{{ total }}</div>
  </div>
</template>
<script>
export default {
  props: {
    theme: {
      type: Object,
      default: () => {
        return {}
      }
    },
    data: {
      type: Object,
      default: null
    },
    backColor: {
      type: String,
      default: 'linear-gradient(270deg, #BA8CE0 0%, #DEC0F2 100%)'
    }
  },
  computed: {
    progress() {
      let res = Math.round((this.index / this.total) * 100)
      if (res < 0) {
        res = 0
      }
      if (res > 100) {
        res = 100
      }
      return res + '%'
    },
    total() {
      let preIndex = 0
      let nextIndex = 0
      for (let i = this.data.questionIndex - 1; i >= 0; i--) {
        if (this.data.question[i].que_type == 7) {
          break
        }
        preIndex++
      }
      for (
        let i = this.data.questionIndex;
        i < this.data.question.length;
        i++
      ) {
        if (this.data.question[i].que_type == 7) {
          break
        }
        nextIndex++
      }
      return preIndex + nextIndex
    },
    index() {
      if (this.data.questionIndex == 0) {
        return 1
      }
      for (let i = this.data.questionIndex - 1; i >= 0; i--) {
        if (this.data.question[i].que_type == 7) {
          return this.data.questionIndex - i
        }
      }
      return this.data.questionIndex
    },
    showPre() {
      for (let i = 0; i < this.data.questionIndex; i++) {
        if (
          this.data.question[i].que_type != 7 &&
          this.data.question[this.data.questionIndex].is_show
        ) {
          return true
        }
      }
      return false
    }
  },
  methods: {
    //上一题
    bindPre() {
      if (this.index > 0) {
        this.$emit('pre')
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.steps {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0px 20px;
  box-sizing: border-box;
  .pre {
    width: 56px;
    font-size: 13px;
    font-family: SourceHanSansCN-Medium, SourceHanSansCN;
    font-weight: 600;
    color: rgba(38, 47, 68, 0.5);
    line-height: 20px;
  }
  .back {
    white-space: nowrap;
  }
  .content {
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
    margin: 0 20px;
    height: 4px;
    border-radius: 2px;
    background-color: rgba(39, 36, 60, 0.1);
    .line {
      height: 100%;
      width: 0%;
      border-radius: 2px;
      transition: width 0.2s linear;
    }
  }
  .cur {
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(58, 55, 82, 0.3);
    line-height: 18px;
    margin-right: 12px;
  }
}
</style>
